<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.26263 6L5.07213 4.9164M5.45901 3.72909C5.45901 4.68405 4.68469 5.45819 3.72951 5.45819C2.77433 5.45819 2 4.68405 2 3.72909C2 2.77414 2.77433 2 3.72951 2C4.68469 2 5.45901 2.77414 5.45901 3.72909Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
